import { useAppStore } from '../lib/store';
import { Category } from '../types/obs';

interface CategoryListProps {
  categories: Category[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function CategoryList({ categories, selectedId, onSelect }: CategoryListProps) {
  const isVertical = useAppStore((state) => state.isVertical);

  return (
    <div className="cat-list">
      {categories.map((cat) => (
        <div
          key={cat.id}
          className={`cat-item ${isVertical && cat.id === 'vertical' ? 'vert-cat' : ''} ${selectedId === cat.id ? 'active' : ''}`}
          onClick={() => onSelect(cat.id)}
        >
          <span>{cat.name}</span>
          <span className="cat-badge">{cat.count}</span>
        </div>
      ))}
    </div>
  );
}
